import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BlockTitle from '../global/typography/BlockTitle';
import P from '../global/typography/P';
import CardContainer from '../global/CardContainer';
import ArticleList from '../global/ArticleList';
import NavLink from '../global/NavLink';

const Container = styled(CardContainer)`
  z-index: 1;
  background-color: transparent;
  box-shadow: none;
  flex-direction: column;

  h1 {
    border: none;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const ViewAll = styled(P)`
  color: ${p => p.theme.color.primary};

  &:hover {
    text-decoration: underline;
  }

  &:after {
    padding-left: 10px;
    font-weight: 500;
    content: '>';
    display: inline-block;
  }
`;

const HomeNewsCard = ({ news = [] }) => (
  <Container flex>
    <Header>
      <BlockTitle>Newsroom</BlockTitle>
      <NavLink to="/news">
        <ViewAll>See More</ViewAll>
      </NavLink>
    </Header>
    <ArticleList articles={news.slice(0, 3)} btnText="View Article" altStyle />
  </Container>
);

const newsShape = PropTypes.shape({
  category: PropTypes.string,
  excerpt: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired
  })
});

HomeNewsCard.propTypes = {
  news: PropTypes.arrayOf(newsShape)
};

export default HomeNewsCard;
